import * as React from "react";

import { UserFormPermissions } from "@simplyk/common";

import { DASHBOARD_PAGE_TRANSLATION_FILES } from "../../../../common/helpers/translationFiles";
import { TunnelLayout } from "../../../../common/layouts/Tunnel/TunnelLayout";

import { AppDashboardProvider } from "@/components/AppProvider/AppDashboardProvider/AppDashboardProvider";
import { DashboardHead } from "@/components/Head/DashboardHead";
import { TicketingLiveFormEditorContainer } from "@/features/LiveFormEditor/TicketingLiveFormEditorContainer";

const TicketsForms = () => {
  return <TicketingLiveFormEditorContainer />;
};

const TicketsFormsLayout = (page: React.ReactElement<unknown>): React.ReactNode => {
  return (
    <>
      {/* Nothing should wrap or block the Head component */}
      <DashboardHead />
      <AppDashboardProvider formPermissions={[UserFormPermissions.EditForm]}>
        <TunnelLayout noScreenPadding>{page}</TunnelLayout>
      </AppDashboardProvider>
    </>
  );
};

TicketsForms.getLayout = TicketsFormsLayout;

TicketsForms.translationNamespaces = DASHBOARD_PAGE_TRANSLATION_FILES;

export default TicketsForms;
